var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-col",
    { staticClass: "mb-1", attrs: { md: _vm.md } },
    [
      _c(
        "b-form-group",
        {
          staticClass: "mb-0",
          attrs: {
            label: _vm.label + ":",
            description: _vm.description,
            "label-class": "filter-header",
          },
        },
        [
          _c(
            "b-input-group",
            [
              _c("b-form-radio-group", {
                staticClass: "fs-14 grey-color",
                attrs: {
                  id: _vm.id,
                  disabled: _vm.disabled,
                  options: _vm.options,
                },
                on: { input: _vm.onFilterChange },
                model: {
                  value: _vm.text,
                  callback: function ($$v) {
                    _vm.text = $$v
                  },
                  expression: "text",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }